import { styled, TableCell } from '@mui/material'
import { COLORS } from '../styles/colors'

export const PlanTableCell = styled(TableCell)(theme => ({
	fontWeight: 400,
	fontSize: '12px',
	lineHeight: '15px',
	color: COLORS.secondary,
	padding: '8px',
}))
